import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootStore } from '../../redux/Store';
import { GetPontosVenda } from '../../redux/actions/PontoVenda';
import { PontoVenda } from '../../redux/actions/PontoVendaTypes';
import {
  DataGrid,
  GridColDef,
  GridCellParams,
  ptBR,
  GridValueFormatterParams,
} from '@material-ui/data-grid';
import {
  makeStyles,
  createTheme,
  ThemeProvider,
} from '@material-ui/core/styles';
import StatusKeepAlive from '../StatusKeepAlive';
import ButtonGrid from '../ButtonGrid';
import { setMaskCnpj} from '../../utils/maskValues';

import './index.scss';

const useStyles = makeStyles({
  root: {
    backgroundColor: '#FFF',
    border: 'none',
  },
  '& .MuiDataGrid-columnHeaderTitleContainer': {
    padding: '0 1px',
  }
});

const theme = createTheme({}, ptBR);

const columns: GridColDef[] = [
  {
    field: 'status',
    headerName: 'Status',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    sortable: false,
    renderCell: (params: GridCellParams) => (
      <StatusKeepAlive pv={Number(params.value)} />
    ),
  },
  {
    field: 'pv',
    headerName: 'PV',
    cellClassName: 'fieldPv',
    headerClassName: 'fieldPv',
    width: 120,
    sortable: true,
    type: 'number',
    
  },
  {
    field: 'nomePontoVenda',
    headerName: 'Nome',
    width: 350,
    flex: 1,
  },
  {
    field: 'cnpjPv',
    headerName: 'CNPJ',
    width: 160,
    flex: 2,
    valueFormatter: (params: GridValueFormatterParams) => {
      return setMaskCnpj(params.value?.toString());
    }
  },
  {
    field: '',
    headerName: '',
    width: 50,
    sortable: true,
    align: 'right',
    renderCell: (params: GridCellParams) => (
      <ButtonGrid
        pv={Number(params.getValue(params.id, 'pv')?.toString())}
        nomePv={params.getValue(params.id, 'nomePontoVenda')?.toString()}
        cnpjPv={params.getValue(params.id, 'cnpjPv')?.toString()}
      />
    ),
  },
];

const Grid: React.FC = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { pontosVendaData } = useSelector(
    (state: RootStore) => state.pontosVenda,
  );
  const { filterData } = useSelector((state: RootStore) => state.pontosVenda);
  const { loading } = useSelector((state: RootStore) => state.pontosVenda);

  const handleGetPontosVenda = () => dispatch(GetPontosVenda());

  useEffect(() => {
    handleGetPontosVenda();
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      handleGetPontosVenda();
    }, Number(process.env.REACT_APP_TEMPO_RECONSULTA_PVS_GRID));
    return () => clearInterval(timer);
  }, []);

  const handleFilterData = useCallback(() => {
    return pontosVendaData.filter((pv: PontoVenda) => {
      if (filterData.type === 'N') {
        return pv.nomePontoVenda
          .toUpperCase()
          .includes(filterData.filter.toUpperCase());
      } else {
        return pv.cnpjPv
          .replace(/[^\d]+/g, '')
          .includes(filterData.filter.replace(/[^\d]+/g, ''));
      }
    });
  }, [filterData, pontosVendaData]);

  return (
    <div id="Grid-Container">
      <ThemeProvider theme={theme}>
        <DataGrid
          sortingOrder={['asc','desc']}
          className={classes.root}
          rows={handleFilterData()}
          columns={columns}
          headerHeight={30}
          rowHeight={25}
          disableColumnSelector={true}
          disableColumnFilter={true}
          disableColumnMenu={true}
          loading={loading}
          hideFooter={true}
        />
      </ThemeProvider>
    </div>
  );
};

export default Grid;
